import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect, useRef, useContext } from 'react';
import DataContext from "../context";
import Loader from "react-js-loader";
const CartMenuItemsModal = () => {
  const contextValues = useContext(DataContext)
  const [isLoading, setisLoadning] = useState(false);
  const didMountRef = useRef(true);
  const toggleCartMenuItemsModal = () => {
    contextValues.setCartMenuItemsModal(!contextValues.toggleCartMenuItems)
  }

  useEffect(() => {
    if (didMountRef.current) {
      setTimeout(() => {
        console.log('toggleCartMenu', contextValues.toggleCartMenu);
      }, 500);
    }
    didMountRef.current = false;
  }, []);

  return (
    <Modal show={contextValues.toggleCartMenuItems} onHide={toggleCartMenuItemsModal} className="addressModal bottom">
      <div className='addressModalContent'>
        <button type="button" className="addressModalclose" onClick={() => { toggleCartMenuItemsModal() }}><i className="ri-close-line"></i></button>
        {isLoading ?
          <Loader type="spinner-default" bgColor={'#a4cc3d'} color={'#a4cc3d'} size={40} />
          :
          <div className='itemModalContent' id='modalscrolltop'>
          <div className='itemModalDetails'>
            {contextValues.toggleCartMenu?.product_tiffin_items?.length > 0 && contextValues.toggleCartMenu?.product_tiffin_items.map((items, categoryIndex) => {
              const totalQty = items?.menu_items?.reduce((sum, item) => sum + (item.qty || 0), 0);

              return (
                items?.tiffin_category?.addon_category === 0 ?
                  <div className='itemModalList' key={categoryIndex}>
                    <div className='itemModalList-header'>
                      <div>
                        <h5 className='mb-1'>{items?.tiffin_category?.category_name}</h5>
                      </div>
                    </div>
                    {items?.menu_items.length > 0 &&
                      <ul>
                        {items?.menu_items?.map((itemsChild, indexchild) => {
                          if (items.pti_moq === 0) {
                            return (
                              <li key={indexchild} >
                                <span>{itemsChild?.item_name}</span>
                              </li>);
                          } else if (items.pti_moq && items.pti_moq === 1 && !!itemsChild.isActive) {
                            return (
                              <li key={indexchild} className={`${itemsChild.isActive ? 'active' : ''}`}>
                                <span>{itemsChild?.item_name} X {itemsChild?.qty}</span>
                              </li>);
                          } else if (itemsChild?.qty > 0) {
                            return (<li key={indexchild}>
                              <span>{itemsChild?.item_name} X {itemsChild?.qty}</span>
                            </li>);
                          }
                        }
                        )}
                      </ul>
                    }
                  </div>
                  :
                  totalQty > 0 &&
                  <div className='itemModalList' key={categoryIndex}>
                    <div className='itemModalList-header'>
                      <div>
                        <h5 className='mb-1'>{items?.tiffin_category?.category_name}</h5>
                      </div>
                    </div>
                    <ul>
                      {items?.menu_items?.map((itemsChild, indexchild) => {
                        if (itemsChild?.qty && itemsChild?.qty > 0) {
                          return (
                            <li key={indexchild}>
                              {itemsChild?.qty && itemsChild?.qty > 0 ? (
                                <span>{itemsChild?.item_name} X {itemsChild?.qty}</span>
                              ) : (
                                <></>
                              )}
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div> 
              );
            })}
          </div>
          </div>
        }
      </div>
    </Modal>
  )
}
export default CartMenuItemsModal;
